import { btn } from '../ui';

export default function TabBar({
  tabs,
  activeTab,
  onSelect,
  showActions,
  onImportPto,
  importDisabled,
  onRebuildClr,
  rebuildDisabled,
  onSync,
  syncDisabled,
}) {
  return (
    <div className="flex justify-between items-end mb-4 border-b">
      <div className="flex gap-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onSelect(tab.id)}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === tab.id
                ? 'border-b-2 border-blue-500 text-blue-600'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {showActions && (
        <div className="flex gap-2 items-center pb-2">
          <button
            onClick={onImportPto}
            className="bg-orange-500 text-white px-3 py-1 rounded text-sm hover:bg-orange-600"
            disabled={importDisabled}
          >
            📥 Import PTO from Calendar
          </button>
          <button
            onClick={onRebuildClr}
            className="bg-slate-600 text-white px-3 py-1 rounded text-sm hover:bg-slate-700 disabled:opacity-50"
            disabled={rebuildDisabled}
            title="Read the CLR events off the calendar and set the rotation order to match"
          >
            🔄 Rebuild CLR from Calendar
          </button>
          <button onClick={onSync} className={btn.save} disabled={syncDisabled}>
            📤 Sync Schedule to Calendar
          </button>
        </div>
      )}
    </div>
  );
}
